import React from "react";

const ManualPage = () => {
    return (
        <object

            data='https://drive.google.com/file/d/1plzQ9gxQcoU4qpAZiKhDo_RYWi2byjuq/preview'
            type='application/pdf'
            style={{ height: '100vh' }}
            width='100%'
            height='700px'
        />
    );
};

export default ManualPage;